export default __webpack_public_path__ + "static/images/Tzuyu_1_thumb.png";